import { createFileRoute } from '@tanstack/react-router';

import { SupplierShopPage } from '@/features/shop/supplier-shop-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/shop/$orgId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierShopPage {...params} />;
}
